import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppComponent } from '@app/app.component';

@Component({
  selector: 'dgx-root',
  template: `
    <ng-content></ng-content>
    <router-outlet></router-outlet>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EbbBootstrapComponent extends AppComponent {}
